var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIconRounded = function SvgCloseIconRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.078,
    d: "M11.97 11.03 9.939 9l2.03-2.03-.027-.028.028.028a.664.664 0 0 0-.94-.94L9 8.061l-2.03-2.03a.664.664 0 1 0-.94.939L8.061 9l-2.03 2.03a.664.664 0 1 0 .939.94l-.028-.028.028.028L9 9.939l2.03 2.03a.664.664 0 0 0 .94-.939ZM4.508 2.277A8.1 8.1 0 0 1 9 .914 8.094 8.094 0 0 1 17.086 9 8.086 8.086 0 1 1 4.508 2.277Z"
  })));
};
export default SvgCloseIconRounded;